import React, { useEffect, useState } from "react";

const UserChecks = ({ questionaire, questionaireSetter, setCanContinue }) => {
  const [newQuestionaire, setNewQuestionaire] = useState();
  const [
    isCurrentlyUnderMedicalTreatment,
    setIsCurrentlyUnderMedicalTreatment,
  ] = useState({ isMedicalTreatment: false, treatments: "" });
  const [isUsingMedicine, setUsingMedicine] = useState({
    isUsingMedicine: false,
    medicines: "",
  });
  const [needsBloodTransf, setNeedsBloodTransf] = useState({
    needsBloodTransf: false,
    reasons: "",
  });
  const [hadSurgery, setHadSurgery] = useState({
    hadSurgery: false,
    which: "",
  });
  const [alergyToMedicine, setAlergyToMedicine] = useState({
    alergyToMedicine: false,
    which: "",
  });
  const [smokes, setSmokes] = useState({
    smokes: false,
    howLong: "",
    howMany: "",
  });
  const [drinks, setDrinks] = useState({
    drinks: false,
    howLong: "",
    howMany: "",
  });
  const [pregnant, setPregnant] = useState({ pregnant: false, weeks: 0 });
  const [canUseAnestesia, setCanUseAnestesia] = useState(false);
  //   const [praxtisId, setPraxisId] = useState(null);

  const newQuestionaireObj = {
    isCurrentlyUnderMedicalTreatment: isCurrentlyUnderMedicalTreatment,
    isUsingMedicine: isUsingMedicine,
    needsBloodTransf: needsBloodTransf,
    hadSurgery: hadSurgery,
    alergyToMedicine: alergyToMedicine,
    smokes: smokes,
    drinks: drinks,
    pregnant: pregnant,
    canUseAnestesia: canUseAnestesia,
  };

  useEffect(() => {
    questionaireSetter(newQuestionaireObj);
  }, [
    isCurrentlyUnderMedicalTreatment,
    isUsingMedicine,
    needsBloodTransf,
    hadSurgery,
    alergyToMedicine,
    smokes,
    drinks,
    pregnant,
    canUseAnestesia,
  ]);

  // Medical questionnaire is optional, so always allow to continue
  useEffect(() => {
    setCanContinue(true);
  }, []);

  return (
    <div className="bg-white shadow-lg rounded-lg p-4 sm:p-6 md:p-8 max-w-4xl mx-auto">
      {/* Header Section */}
      <div className="mb-6">
        <h2 className="text-2xl sm:text-3xl font-bold mb-3 text-gray-800">
          Información Médica
        </h2>
        <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
          Completá tu historial médico para brindarte una mejor atención odontológica.
        </p>
      </div>

      {/* Form Section */}
      <div className="space-y-6">
        {/* Medical Treatment */}
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="flex items-start space-x-3">
            <input
              type="checkbox"
              id="medicalTreatment"
              className="w-5 h-5 mt-0.5 text-blue-600 bg-white border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
              checked={isCurrentlyUnderMedicalTreatment.isMedicalTreatment}
              onChange={(e) =>
                setIsCurrentlyUnderMedicalTreatment({
                  isMedicalTreatment: e.target.checked,
                  treatments: [],
                })
              }
            />
            <label
              htmlFor="medicalTreatment"
              className="text-sm sm:text-base text-gray-900 cursor-pointer flex-1"
            >
              ¿Está siendo sometido a algún tratamiento médico actualmente?
            </label>
          </div>
        </div>
        {/* Medicine Usage */}
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="flex items-start space-x-3 mb-3">
            <input
              type="checkbox"
              id="useOfMedicine"
              className="w-5 h-5 mt-0.5 text-blue-600 bg-white border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
              checked={isUsingMedicine.isUsingMedicine}
              onChange={(e) =>
                setUsingMedicine({
                  isUsingMedicine: e.target.checked,
                  medicines: "",
                })
              }
            />
            <label
              htmlFor="useOfMedicine"
              className="text-sm sm:text-base text-gray-900 cursor-pointer flex-1"
            >
              ¿Está haciendo uso de algún medicamento?
            </label>
          </div>
          {isUsingMedicine.isUsingMedicine && (
            <div className="ml-8">
              <input
                placeholder="¿Cuáles medicamentos?"
                onChange={(e) => {
                  setUsingMedicine({
                    isUsingMedicine: isUsingMedicine.isUsingMedicine,
                    medicines: e.target.value,
                  });
                }}
                className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                value={isUsingMedicine.medicines}
              />
            </div>
          )}
        </div>
        {/* Blood Transfusion */}
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="flex items-start space-x-3 mb-3">
            <input
              type="checkbox"
              id="bloodTreatment"
              className="w-5 h-5 mt-0.5 text-blue-600 bg-white border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
              checked={needsBloodTransf.needsBloodTransf}
              onChange={(e) =>
                setNeedsBloodTransf({
                  needsBloodTransf: e.target.checked,
                  reasons: "",
                })
              }
            />
            <label
              htmlFor="bloodTreatment"
              className="text-sm sm:text-base text-gray-900 cursor-pointer flex-1"
            >
              ¿Recibió transfusión sanguínea anteriormente?
            </label>
          </div>
          {needsBloodTransf.needsBloodTransf && (
            <div className="ml-8">
              <input
                placeholder="¿Motivo?"
                onChange={(e) =>
                  setNeedsBloodTransf({
                    needsBloodTransf: needsBloodTransf.needsBloodTransf,
                    reasons: e.target.value,
                  })
                }
                className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                value={needsBloodTransf.reasons}
              />
            </div>
          )}
        </div>

        {/* Surgery */}
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="flex items-start space-x-3 mb-3">
            <input
              type="checkbox"
              id="surgery"
              className="w-5 h-5 mt-0.5 text-blue-600 bg-white border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
              checked={hadSurgery.hadSurgery}
              onChange={(e) =>
                setHadSurgery({
                  hadSurgery: e.target.checked,
                  which: "",
                })
              }
            />
            <label
              htmlFor="surgery"
              className="text-sm sm:text-base text-gray-900 cursor-pointer flex-1"
            >
              ¿Fue sometido a alguna cirugía?
            </label>
          </div>
          {hadSurgery.hadSurgery && (
            <div className="ml-8">
              <input
                placeholder="¿Cuál cirugía?"
                onChange={(e) =>
                  setHadSurgery({
                    hadSurgery: hadSurgery.hadSurgery,
                    which: e.target.value,
                  })
                }
                className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                value={hadSurgery.which}
              />
            </div>
          )}
        </div>

        {/* Allergies */}
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="flex items-start space-x-3 mb-3">
            <input
              type="checkbox"
              id="allergies"
              className="w-5 h-5 mt-0.5 text-blue-600 bg-white border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
              checked={alergyToMedicine.alergyToMedicine}
              onChange={(e) =>
                setAlergyToMedicine({
                  alergyToMedicine: e.target.checked,
                  which: "",
                })
              }
            />
            <label
              htmlFor="allergies"
              className="text-sm sm:text-base text-gray-900 cursor-pointer flex-1"
            >
              ¿Presenta alergia a algún alimento o medicamento?
            </label>
          </div>
          {alergyToMedicine.alergyToMedicine && (
            <div className="ml-8">
              <input
                placeholder="¿A cuál?"
                onChange={(e) =>
                  setAlergyToMedicine({
                    alergyToMedicine: alergyToMedicine.alergyToMedicine,
                    which: e.target.value,
                  })
                }
                className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                value={alergyToMedicine.which}
              />
            </div>
          )}
        </div>

        {/* Smoking */}
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="flex items-start space-x-3 mb-3">
            <input
              id="smoke"
              type="checkbox"
              className="w-5 h-5 mt-0.5 text-blue-600 bg-white border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
              checked={smokes.smokes}
              onChange={(e) =>
                setSmokes({
                  smokes: e.target.checked,
                  howLong: 0,
                  howMany: 0,
                })
              }
            />
            <label
              htmlFor="smoke"
              className="text-sm sm:text-base text-gray-900 cursor-pointer flex-1"
            >
              ¿Fuma?
            </label>
          </div>
          {smokes.smokes && (
            <div className="ml-8 space-y-3">
              <div>
                <label className="block text-xs sm:text-sm text-gray-600 mb-1">
                  ¿Hace cuánto tiempo? (Meses)
                </label>
                <input
                  type="number"
                  min="0"
                  className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full sm:w-32 p-2"
                  value={smokes.howLong}
                  onChange={(e) =>
                    setSmokes({
                      smokes: smokes.smokes,
                      howLong: e.target.value,
                      howMany: smokes.howMany,
                    })
                  }
                />
              </div>
              <div>
                <label className="block text-xs sm:text-sm text-gray-600 mb-1">
                  Cantidad por día
                </label>
                <input
                  type="number"
                  min="0"
                  className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full sm:w-32 p-2"
                  value={smokes.howMany}
                  onChange={(e) =>
                    setSmokes({
                      smokes: smokes.smokes,
                      howLong: smokes.howLong,
                      howMany: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          )}
        </div>

        {/* Alcohol */}
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="flex items-start space-x-3 mb-3">
            <input
              id="drinks"
              type="checkbox"
              className="w-5 h-5 mt-0.5 text-blue-600 bg-white border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
              checked={drinks.drinks}
              onChange={(e) =>
                setDrinks({
                  drinks: e.target.checked,
                  howLong: 0,
                  howMany: 0,
                })
              }
            />
            <label
              htmlFor="drinks"
              className="text-sm sm:text-base text-gray-900 cursor-pointer flex-1"
            >
              ¿Toma bebidas alcohólicas?
            </label>
          </div>
          {drinks.drinks && (
            <div className="ml-8 space-y-3">
              <div>
                <label className="block text-xs sm:text-sm text-gray-600 mb-1">
                  ¿Hace cuánto tiempo? (Meses)
                </label>
                <input
                  type="number"
                  min="0"
                  className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full sm:w-32 p-2"
                  value={drinks.howLong}
                  onChange={(e) =>
                    setDrinks({
                      drinks: drinks.drinks,
                      howLong: e.target.value,
                      howMany: drinks.howMany,
                    })
                  }
                />
              </div>
              <div>
                <label className="block text-xs sm:text-sm text-gray-600 mb-1">
                  Cantidad por día
                </label>
                <input
                  type="number"
                  min="0"
                  className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full sm:w-32 p-2"
                  value={drinks.howMany}
                  onChange={(e) =>
                    setDrinks({
                      drinks: drinks.drinks,
                      howLong: drinks.howLong,
                      howMany: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          )}
        </div>

        {/* Pregnancy */}
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="flex items-start space-x-3 mb-3">
            <input
              id="pregnant"
              type="checkbox"
              className="w-5 h-5 mt-0.5 text-blue-600 bg-white border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
              checked={pregnant.pregnant}
              onChange={(e) =>
                setPregnant({
                  pregnant: e.target.checked,
                  weeks: 0,
                })
              }
            />
            <label
              htmlFor="pregnant"
              className="text-sm sm:text-base text-gray-900 cursor-pointer flex-1"
            >
              ¿Declara estar embarazada?
            </label>
          </div>
          {pregnant.pregnant && (
            <div className="ml-8">
              <label className="block text-xs sm:text-sm text-gray-600 mb-1">
                ¿Cuántas semanas?
              </label>
              <input
                type="number"
                min="0"
                max="42"
                className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full sm:w-32 p-2"
                value={pregnant.weeks}
                onChange={(e) =>
                  setPregnant({
                    pregnant: pregnant.pregnant,
                    weeks: parseInt(e.target.value) || 0,
                  })
                }
              />
            </div>
          )}
        </div>

        {/* Anesthesia */}
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="flex items-start space-x-3">
            <input
              id="anesthesia"
              type="checkbox"
              className="w-5 h-5 mt-0.5 text-blue-600 bg-white border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
              checked={canUseAnestesia}
              onChange={(e) => setCanUseAnestesia(e.target.checked)}
            />
            <label
              htmlFor="anesthesia"
              className="text-sm sm:text-base text-gray-900 cursor-pointer flex-1"
            >
              ¿Tolera la anestesia de uso odontológico?
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserChecks;
